import type { DoraICTService } from './doraICTService.ts';
import type { DoraFinding } from './doraFinding.ts';

export interface DoraTestingExercise {
  id?: number;
  name: string;
  description?: string | null;
  executed_at?: string | null;
  exercise_type?: string | null;
  ict_service_id?: number | null;
  ict_service?: DoraICTService | null;
  findings?: DoraFinding[];
}

export type DoraTestingExerciseUpdate = Partial<Omit<DoraTestingExercise,
  'id' |
  'ict_service' |
  'findings'
>>;

export const doraTestingExerciseToUpdate = ({
  id,
  ict_service,
  findings,
  ...rest
}: DoraTestingExercise): DoraTestingExerciseUpdate => ({
  ...rest,
});
